import React, { useState } from 'react';

function MobileDoctorSettings({ onBack }) {
  const [settings, setSettings] = useState({
    notifications: true,
    emailAlerts: true,
    patientRequests: true,
    reportUploads: true,
    language: 'English',
  });

  const toggle = (key) => setSettings(prev => ({ ...prev, [key]: !prev[key] }));

  return (
    // REMOVED 'pt-16' TO ELIMINATE THE TOP GAP
    <div className="pb-6 bg-[#f9f9fc] min-h-full" style={{ fontFamily: 'Inter, sans-serif' }}>
      
      {/* SUB-SCREEN HEADER */}
      <div className="bg-white px-4 py-3 flex items-center gap-3 border-b border-gray-100 shadow-xs sticky top-0 z-10">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 active:scale-95 transition-all">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <span className="font-black text-[#0d1b2a] text-base">Settings</span>
      </div>

      <div className="px-4 py-4 space-y-4">
        {/* Notifications */}
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2 ml-1">Notifications</p>
          <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden" style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
            {[
              { key: 'notifications', label: 'Push Notifications', icon: 'notifications', desc: 'Receive app notifications' },
              { key: 'emailAlerts', label: 'Email Alerts', icon: 'mail', desc: 'Get updates via email' },
              { key: 'patientRequests', label: 'Patient Requests', icon: 'person_add', desc: 'Notify on new access requests' },
              { key: 'reportUploads', label: 'Report Uploads', icon: 'upload_file', desc: 'Notify when patient uploads report' },
            ].map(item => (
              <div key={item.key} className="flex items-center justify-between px-4 py-3 border-b border-gray-50 last:border-b-0">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 bg-[#0B3C95]/10 rounded-xl flex items-center justify-center">
                    <span className="material-symbols-outlined text-[#0B3C95] text-lg">{item.icon}</span>
                  </div>
                  <div>
                    <p className="font-semibold text-sm text-[#1a1c1e]">{item.label}</p>
                    <p className="text-xs text-gray-400">{item.desc}</p>
                  </div>
                </div>
                <button onClick={() => toggle(item.key)}
                  className={`w-12 h-6 rounded-full transition-all ${settings[item.key] ? 'bg-[#0B3C95]' : 'bg-gray-200'}`}>
                  <div className={`w-5 h-5 bg-white rounded-full shadow-sm transition-all mx-0.5 ${settings[item.key] ? 'translate-x-6' : 'translate-x-0'}`}></div>
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Preferences */}
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2 ml-1">Preferences</p>
          <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden" style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
            <div className="flex items-center justify-between px-4 py-3">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-gray-100 rounded-xl flex items-center justify-center">
                  <span className="material-symbols-outlined text-gray-500 text-lg">language</span>
                </div>
                <div>
                  <p className="font-semibold text-sm text-[#1a1c1e]">Language</p>
                  <p className="text-xs text-gray-400">App display language</p>
                </div>
              </div>
              <span className="text-xs font-bold text-[#0B3C95]">English</span>
            </div>
          </div>
        </div>

        {/* About */}
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2 ml-1">About</p>
          <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden" style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
            <div className="px-4 py-3 border-b border-gray-50">
              <p className="font-semibold text-sm text-[#1a1c1e]">Version</p>
              <p className="text-xs text-gray-400">1.0.0</p>
            </div>
            <div className="px-4 py-3">
              <p className="font-semibold text-sm text-[#1a1c1e]">Made with ❤️ in India</p>
              <p className="text-xs text-gray-400">VH Mobile Metrics Pvt Ltd</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileDoctorSettings;